import { useQuery } from 'react-query';
import { getInquiriesByClient } from '../../api/vendors';

/**
 * Fetch inquiries for a client. Shared cache so parent + child components
 * reading the same client's inquiries don't duplicate requests.
 */
function useClientInquiries(clientId, { enabled = true } = {}) {
  return useQuery(
    ['client-inquiries', clientId],
    async () => getInquiriesByClient(clientId),
    {
      enabled: !!clientId && enabled,
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000,
    },
  );
}

export default useClientInquiries;
